import React, { useRef, useState } from 'react';
import axios from 'axios';
import "./BusinessPhone.css";
import flashMessage from '../HelperFunctions';


function BusinessPhone({ organization, onChange }) {
  const [isSaving, setIsSaving] = useState(false);  // State to handle "saving..." message
  const placeholderText = `555-555-5555`;

  const typingTimer = useRef(null);
  const phoneInputRef = useRef(null);

  const handleInputChange = (e) => {
    onChange(e.target.value);
  };

  return (

    <div style={{ width: 180 }}  className="customize-ai-section">
      <span>Main Phone Number</span>
      <input
        data-say-id="knowledge-base-phone"
        ref={phoneInputRef}
        className="business-phone-text"
        placeholder={placeholderText}
        defaultValue={organization.business_phone_number}
        onChange={handleInputChange}
      />
    </div>

  );
}

export default BusinessPhone
